import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http'
import { lastValueFrom, Observable, Subject, throwError } from 'rxjs';
import {catchError} from 'rxjs/operators';


import {dasa} from '../../classess/dasaClasses';
import { image } from 'html2canvas/dist/types/css/types/image';

@Injectable({
  providedIn: 'root'
})
export class commonService {
private subject = new Subject<any>();
  static doAPICall: any;

  constructor(private http :HttpClient) { }


sendMessage(message:string)
{
  this.subject.next(message)
}
getMessage(): Observable<any>
{
  return this.subject.asObservable();
}
clearMessages()
{
  this.subject.next;
}


getAPICall(request: any, url: string): Observable<any> {
  return this.http.get(url, { params: request })
    .pipe(catchError(this.formatErrors));
}


  doAPICall(request:any, url:string) :Observable <any>
  {
      return  this.http.post(url ,request)
      .pipe(catchError(this.formatErrors))
  }

  doAPICall_await(request:any, url:string)
  {
      return lastValueFrom(this.http.post(url ,request));

      // try {
      //   const v= lastValueFrom(this.http.post(url ,request));
      //   return v;

      // } catch (error) {
      //   console.log("ERROR", error);
      // }

  }
  // common.service.ts
doDelete(url: string) {
  return this.http.delete(url); // add headers here if you use auth
}




  private formatErrors(error :any)
  {
    return throwError(error.error)
  }
  // ---- WhatsApp inbox -----------------------------------------------------
  // These used to call gate.whapi.cloud directly from the browser using a
  // bearer token compiled into the bundle — readable by anyone who opened
  // devtools. Everything now goes through the backend, which holds the
  // credential and resolves the *store's own* token rather than a shared one.
  //
  // Only the operations the support inbox actually uses are exposed; the ~20
  // other WhAPI wrappers that lived here had no callers and were deleted
  // rather than proxied.

  private inboxBase = environment.NEW_BACKEND_URL + 'api/whatsapp/inbox';

  private storeId(): number {
    return dasa.Utility.selectedStoreId;
  }

  getWhatsAppChats(count: number, offset: number): Observable<any> {
    const params = new HttpParams()
      .set('storeId', String(this.storeId()))
      .set('count', String(count))
      .set('offset', String(offset));
    return this.http.get(`${this.inboxBase}/chats`, { params })
      .pipe(catchError(this.formatErrors));
  }

  getWhatsAppMessages(chatId: string, count: number, offset: number): Observable<any> {
    const params = new HttpParams()
      .set('storeId', String(this.storeId()))
      .set('count', String(count))
      .set('offset', String(offset));
    return this.http.get(`${this.inboxBase}/messages/${encodeURIComponent(chatId)}`, { params })
      .pipe(catchError(this.formatErrors));
  }

  sendWhatsAppText(to: string, body: string, quoted?: string): Observable<any> {
    return this.http.post(`${this.inboxBase}/send/text`,
      { storeId: this.storeId(), to, body, quoted })
      .pipe(catchError(this.formatErrors));
  }

  sendWhatsAppImage(to: string, media: any, caption?: string): Observable<any> {
    return this.http.post(`${this.inboxBase}/send/image`,
      { storeId: this.storeId(), to, media, caption })
      .pipe(catchError(this.formatErrors));
  }

  reactWhatsAppMessage(messageId: string, emoji: string): Observable<any> {
    return this.http.put(`${this.inboxBase}/messages/${encodeURIComponent(messageId)}/reaction`,
      { storeId: this.storeId(), emoji })
      .pipe(catchError(this.formatErrors));
  }

  deleteWhatsAppMessage(messageId: string): Observable<any> {
    const params = new HttpParams().set('storeId', String(this.storeId()));
    return this.http.delete(`${this.inboxBase}/messages/${encodeURIComponent(messageId)}`, { params })
      .pipe(catchError(this.formatErrors));
  }

  readWhatsAppMessage(messageId: string): Promise<any> {
    const params = new HttpParams().set('storeId', String(this.storeId()));
    return lastValueFrom(
      this.http.put(`${this.inboxBase}/messages/${encodeURIComponent(messageId)}/read`, {}, { params })
    );
  }

  /** Media is streamed through the backend so the WhAPI URL never reaches the browser. */
  fetchWhatsAppImage(mediaId: string): Promise<string | ArrayBuffer | null> {
    const params = new HttpParams().set('storeId', String(this.storeId()));
    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.inboxBase}/media/${encodeURIComponent(mediaId)}`,
             { params, responseType: 'blob' })
        .subscribe(
          blob => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          },
          error => reject(error)
        );
    });
  }


}
